<template>
  <div>

    <div
      :style="setPickerDesign"
    >
      <input :key="counter" type="file" :id="id" v-bind:value="valuee" @change="getFile" hidden multiple/>

      <div class="spacing icon">
        <img :src="getImage()" width="20px" height="20px"/>
      </div>
      <div class="spacing" v-if="allFiles.length==1||allFiles.length==0" >
        <span v-if="fileName == null " class="upload-file">{{description}}</span>
        <span v-else-if="fileName != null" class="upload-file"><U>{{fileName}}</U></span>
      </div>
      <div class="spacing" v-else>
        <span class="upload-file"><U>{{allFiles.length}} files selected</U></span>
      </div>

      <div class="spacing">
        <!-- <span class="upload_message" v-if="errorFlag == false && successFlag == false">
          Upload a File
        </span> -->
        <img style="background-color: white !important;" src="../assets/Info.png" width="18px" height="18px" class="info" :title="infoIconText" />
        <img v-if="successFlag||errorFlag" src="../assets/close.png" width="18px" height="19px" class="delete" title="Remove File" @click="removeFile" />
      </div>


        <label :for="id" v-if="(errorFlag == true && successFlag == false) || (errorFlag == false && successFlag == false)">
            <div
              :style="setFileButtonDesign"
              class="hoverDesign"
            >
          Upload
        </div>   
        </label>
        <label :for="id" v-if="(errorFlag == false && successFlag == true)">
            <div
             :style="setFileButtonDesign"
              class="hoverDesign"
              >
              Re-Upload
            </div>
        </label>
      </div>

      <span class="upload_message_success" v-if="errorFlag == false & successFlag == true">
        Successfully Uploaded
      </span>
      <span class="upload_message_error" v-if=" errorFlag == true && successFlag == false">
        {{errorMsg}}
      </span>
  </div>
</template>

<script>
import { watch } from 'fs';

export default {
  name: "SFilePicker",

  computed: {
    setPickerDesign(){
      if(this.errorFlag == true && this.successFlag == false){
        return {
           "border": "1px solid var(--very-light-pink)",
           "background-color": "#fff2f2",
           "border-radius": "2px",
           "height": "inherit",
           "display": "grid",
           "grid-template-columns": "0.21fr 1.5fr 1.5fr 1fr"

        }
      }
      else if(this.errorFlag == false & this.successFlag == true){
        return{
           "border": "1px solid var(--very-light-pink)",
           "background-color": "#fafef2",
           "border-radius": "2px",
           "height": "inherit",
           "display": "grid",
           "grid-template-columns": "0.21fr 1.5fr 1.5fr 1fr"
        }
      }
      else{
        return{
           "border": "1px solid var(--very-light-pink)",
           "background-color": "var(--white)",
           "border-radius": "2px",
           "height": "inherit",
           "display": "grid",
           "grid-template-columns": "0.21fr 1.5fr 1.5fr 1fr"
        }
      }
    },
    setFileButtonDesign(){
      if(this.errorFlag == true && this.successFlag == false){
        return {
          "text-align": "center",
          "font-family": "Roboto",
          "font-weight": "bold",
          "padding": "14px",
          "font-size": "14px",
          "background-color": "#ffd9d9",
          "border": "1px solid var(--very-light-pink)"
        }
      }
      else if(this.errorFlag == false & this.successFlag == true){
        return{
          "text-align": "center",
          "font-family": "Roboto",
          "font-weight": "bold",
          "padding": "14px",
          "font-size": "14px",
          "background-color": "#EBFFE1",
          "border": "1px solid var(--very-light-pink)"
        }
      }
      else{
        return{
          "text-align": "center",
          "font-family": "Roboto",
          "font-weight": "bold",
          "padding": "14px",
          "font-size": "14px",
          "background-color": "var(--very-light-pink)",
          "border": "1px solid var(--very-light-pink)"
        }
      }
    }
  },

  props: {
    value:{},
    fileSize:{
      type:Number,
      default:15,
    },

  },

  data() {
    return {
      fileName: null,
      description: "Maximum upload size: " + this.fileSize +" MB",
      errorFlag: false,
      successFlag: false,
      size: null,
      type: null,
      infoIconText: 'Upload a file',
      valuee: this.fileName,
      id: this._uid,
      errorMsg: '',
      allFiles: [],
      counter:null
    };
  },

  methods: {
    getImage(){
      // showing error image
      if(this.errorFlag == true && this.successFlag == false){
        return require('../assets/Document_Red.png');
      }
      // showing success image
      else if(this.errorFlag == false & this.successFlag == true){
        return require('../assets/Document_Green.png');
      }
      // showing normal image
      else{
        return require('../assets/Document.png');
      }
    },

    getFile(e){
      // console.log('file: ',e.target.files);
      this.allFiles = e.target.files;

      // resetting flags
      this.resetFlags();

      //getting file name
      this.fileName = e.target.files[0].name;

      if(this.fileName != null){
          this.checkSize(this.allFiles);

          if(this.successFlag){
            if(this.allFiles.length>1){
              this.infoIconText = "Multiple files uploaded";
              this.$emit('input', e.target.files); // if multiple files are uploaded
            }
            else{
              this.showInfoTooltipText(e.target.files[0]);
              this.$emit('input', e.target.files[0]); //in case of single file
            }
          }
      }
      else{
        this.errorFlag = true;
      }
    },

    showInfoTooltipText(file){
      var totalSizeMB = (file.size / Math.pow(1024,2)).toFixed(2);
      var fileType = file.name.split(".");
      this.type = fileType[fileType.length-1];
      this.infoIconText = "Type: " + this.type + "\nSize: " + totalSizeMB + " MB";
    },

    resetFlags(){
      this.successFlag = false;
      this.errorFlag = false;
    },

    removeFile(){
      this.fileName = null;
      if(this.successFlag){
        this.infoIconText = 'Upload a file';
        this.description = "Maximum upload size: " + this.fileSize + "MB";
        this.successFlag = false;
      }
      else if(this.errorFlag){
        this.infoIconText = 'Upload a file';
        this.description = "Maximum upload size: " + this.fileSize + "MB";
        this.errorFlag = false;
      }
      this.$emit('cancel');
    },

    checkSize(files){
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        var size = Number(file.size / Math.pow(1024,2));
        if(size > this.fileSize){
          this.errorFlag = true;
          this.errorMsg = 'File is exceeding upload limit. Please upload again.'
          this.showInfoTooltipText(file);
          break;
        }
      }

      if(!this.errorFlag){
        this.successFlag = true;
        // this.$emit('input', file);
        // this.showInfoTooltipText(file);
      }

    
    }
   
  }
  ,
  watch:{
      fileSize(newVal, oldVal){
         
         
       
          if( this.fileSize>0 ||  this.fileSize==0){
            this.fileSize=newVal;
          this.description= "Maximum upload size: " + newVal +" MB" ;
   

       }
       else if(this.fileSize>0){
        this.fileSize=newVal;
          this.description= "Maximum upload size: " + newVal +" MB" ;
       }
   
}
      }
    

};
</script>

<style lang="scss" scoped>
label {
  border-radius: 18px;
  background-color: var(--white);
  cursor: pointer;
  position: inherit;
  margin: 0;
  text-align: right;
  padding: 10px 30px;
  color: #000000;
    font-family: "Roboto !important";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.upload_message {
    font-family: "Roboto !important";
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  padding-left: 5px;
}
.upload_message_success {
    font-family: "Roboto !important";
  font-size: 13px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #a4e600;
  padding-left: 5px;
}
.upload_message_error {
    font-family: "Roboto !important";
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ff0000;
  padding-left: 5px;
}
.upload-file {
    font-family: "Roboto !important";
  font-size: 14px;
  // font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  cursor:default;
}
.spacing{
  padding: 10px 0px 10px 10px;
  text-align: start;
}
label{
  border-radius: 0;
  background-color: transparent;
  padding: 0;
}
.info{
  position: relative;
  left: 80%;
  // padding-right: 16px;
  // padding-top: 2px;
  opacity: 0.3;
  cursor: pointer;
}
.icon{
  // border-right: 1px solid var(--very-light-pink);
  // margin-right: 16px;
}
.hoverDesign:hover{
  background-color: var(--secondary) !important;
  cursor: pointer;
  color: var(--white);

  label {
      color: var(--white) !important;
  }
}
.delete{
  float: right;
  margin-top: 2px;
  margin-right: 8px;
  margin-left: -8px;
  cursor: pointer;
  opacity: 0.7;
}
</style>